import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2OnModule } from 'angulartics2';

import { LoaderModule, UtilsModule } from '@tablesready/common-ui';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { DateFormatPipe } from '@tablesready/frontend-pipes';

import { WaitlistNotifyComponent } from './waitlist-notify.component';

@NgModule({
  declarations: [WaitlistNotifyComponent],
  exports: [WaitlistNotifyComponent],
  imports: [
    CommonModule,
    FrontendIconsModule,
    Angulartics2OnModule,
    NgbTooltipModule,
    UtilsModule,
    LoaderModule,
    DateFormatPipe,
  ],
})
export class WaitlistNotifyModule {}
